module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/invoice-list/invoice-list.component.css
// module id = ./src/app/invoice-list/invoice-list.component.css
// module chunks = main